import { PageHeaderBody } from "Shared/Layouts/components/PageHeaderBody";
import type { Breadcrumb } from "Shared/Layouts/components/types";
import type { ReactNode } from "react";

type Props = {
	title: string;
	subtitle?: string;
	breadcrumbs?: Breadcrumb[];
	actions?: ReactNode;
	clientSwitcher?: ReactNode;
};

/**
 * Secondary row showing the current page's title, breadcrumbs, and actions.
 * Renders below `TopbarNav` on wide viewports; hidden below `md` because
 * `DrawerNav.Topbar` already shows the same info next to the hamburger.
 */
export const PageHeader = ({
	title,
	subtitle,
	breadcrumbs,
	actions,
	clientSwitcher,
}: Props) => (
	<div className="border-border bg-card hidden h-14 flex-shrink-0 items-center gap-3 border-b px-6 md:flex">
		<PageHeaderBody
			title={title}
			subtitle={subtitle}
			breadcrumbs={breadcrumbs}
			clientSwitcher={clientSwitcher}
		/>
		{actions ? (
			<div className="flex flex-shrink-0 items-center gap-2">{actions}</div>
		) : null}
	</div>
);
